export default __webpack_public_path__ + "static/media/About-content.2c629506.md";